import React from 'react';
import { Lock } from 'lucide-react';

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
  useSidebar,
} from '@/components/ui/sidebar/sidebar';
import { cn } from '@/utils/tailwind';
import { Link } from 'react-router-dom';
import { NavUser } from './navUser';
import { useSidebarLinks } from '@/hooks/useSidebarLinks';
import { NavLink } from 'react-router-dom';
import { useUser } from '@/providers/userProvider';

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const sidebarContext = useSidebar();
  const links = useSidebarLinks();
  const { user } = useUser();

  return (
    <Sidebar
      collapsible="icon"
      className={cn('bg-sidebar-primary-light', props.className ?? '')}
      {...props}
    >
      <SidebarHeader className="pl-6 pt-4">
        <Link to="/home">
          <img
            src="/logo.png"
            alt="Zeos"
            className="h-4 w-auto max-w-none brightness-0 invert transition-all duration-200 group-data-[collapsible=icon]:h-2.5"
          />
        </Link>
      </SidebarHeader>
      <SidebarContent
        className="pl-2.5 pt-2"
        onMouseEnter={() => sidebarContext.setOpen(true)}
        onMouseLeave={() => sidebarContext.setOpen(false)}
      >
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu className="gap-4">
              {links.navMain.map((link) => (
                <SidebarMenuItem key={link.url}>
                  <SidebarMenuButton
                    tooltip={link.locked ? `${link.title} (Subscriber)` : link.title}
                    className={cn(
                      "hover:bg-base-link hover:text-white text-white font-light",
                      link.locked && "opacity-70"
                    )}
                    asChild
                  >
                    <NavLink
                      to={link.url}
                      onClick={() => sidebarContext.setOpenMobile(false)}
                    >
                      <link.icon
                        style={{
                          width: 20,
                          height: 20,
                        }}
                      />
                      <span className="flex items-center gap-2">
                        {link.title}
                        {link.locked && <Lock className="w-3 h-3" />}
                      </span>
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter onMouseEnter={() => sidebarContext.setOpen(true)}>
        <NavUser
          user={{
            name: user?.first_name ?? '',
            email: user?.email ?? '',
            avatar: '/martcart-app-icon.svg',
          }}
        />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
